import React, { useEffect, useState } from "react";
import { toolsAPI } from "../../../utils/funcionesAPI";
import { withRouter } from "react-router-dom";
import { getLocalidadesPorPartido, getPartidosPorProvincia, manejadorDeRespuesta } from "../../../utils/Tools";
import PropTypes from "prop-types";

const DatosPersonales = (props) => {
  const [tiposDocumento, setTiposDeDocumento] = useState([]);
  const [nacionalidades, setNacionalidades] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [partidos, setPartidos] = useState([]);
  const [localidades, setLocalidades] = useState([]);
  const [categoriasIVA, setCategoriasIva] = useState([]);

  const { usuario } = props;

  useEffect(() => {
    let data = JSON.stringify({ accion: "tiposDeDocumento" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setTiposDeDocumento(respuesta.data);
    });

    data = JSON.stringify({ accion: "paises" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setNacionalidades(respuesta.data);
    });

    data = JSON.stringify({ accion: "provincias" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setProvincias(respuesta.data);
    });

    data = JSON.stringify({ accion: "categoriasIVA" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setCategoriasIva(respuesta.data);
    });
    
  }, []);

  useEffect(() => {

    getPartidosPorProvincia(usuario.cliente.provincia.codigo, setPartidos);
    getLocalidadesPorPartido(usuario.cliente.partido.codigo, setLocalidades);
    
  }, [usuario]);

  const handleInputChange = (e) => {
    props.onInputsChange(e.target.name, e.target.value);
  };

  const handleInputUsuarioChange = (e) => {
    props.onInputsUsuarioChange(e.target.name, e.target.value);
  };

  const handleTipoDocumentoChange = (e) => {
    let sigla = e.target.value;
    props.onInputsChange(
      e.target.name,
      tiposDocumento.find((e) => e.sigla === sigla)
    );
  };

  const handleCategoriaIvaChange = (e) => {
    let idCategoria = e.target.value;
    props.onInputsChange(
      e.target.name,
      categoriasIVA.find((e) => e.id === idCategoria)
    );
  };

  const handlePaisChange = (e) => {
    let codigo = e.target.value;
    props.onInputsChange(
      e.target.name,
      nacionalidades.find((e) => e.codigo === codigo)
    );
  };

  const handleProvinciaChange = (e) => {
    let codigo = e.target.value;
    props.onInputsChange(
      e.target.name,
      provincias.find((e) => e.codigo === codigo)
    );
    getPartidosPorProvincia(codigo, setPartidos);
  };

  const handlePartidoChange = (e) => {
    let codigo = e.target.value;
    props.onInputsChange(
      e.target.name,
      partidos.find((e) => e.codigo === codigo)
    );
    getPartidosPorProvincia(codigo, setPartidos);
  };

  const handleLocalidadChange = (e) => {
    let idLocalidad = e.target.value;
    props.onInputsChange(
      e.target.name,
      localidades.find((e) => e.id === idLocalidad)
    );
    
  };

  const handleGuardarDatosPersonalesClick = (e) => {
    e.preventDefault();
    props.onActualizarDatosPersonalesClick();
  };

  

  return (
    <div className="row col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 form">
      <h2 className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        datos personales
      </h2>
      <form
        action="#"
        method="post"
        className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 row"
      >
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 title">
          <div className="input-group">
            <label className="labelPerfil" htmlFor="nombre">
              Nombre
            </label>
            <input
              type="text"
              value={usuario.nombre}
              name="nombre"
              placeholder="Nombre"
              onChange={handleInputUsuarioChange}
            />
            <div className="input-group-append">
              <label className="input-group-text" htmlFor="nombre">
                *
              </label>
            </div>
          </div>

          {usuario.tipoCliente !== "IND" ? (
            <div className="input-group">
              <label className="labelPerfil" htmlFor="nombreAgencia">
                Nombre de Agencia
              </label>
              <input
                value={usuario.cliente.denominacion}
                name="nombreAgencia"
                placeholder="Nombre Agencia"
                type="text"
                onChange={handleInputChange}
              />
              <div className="input-group-append">
                <label className="input-group-text" htmlFor="nombreAgencia">
                  *
                </label>
              </div>
            </div>
          ) : null}

          {usuario.tipoCliente !== "IND" ? (
            <div>
              <label className="labelPerfil" htmlFor="categoriaIVA">
                Categoría IVA
              </label>
              <div className="input-group">
                <select
                  className="custom-select"
                  name="categoriaIVA"
                  value={usuario.cliente.categoriaIVA.id}
                  onChange={handleCategoriaIvaChange}
                >
                  {categoriasIVA.map((categoria) => {
                    return (
                      <option key={categoria.id} value={categoria.id}>
                        {categoria.denominacion}
                      </option>
                    );
                  })}
                </select>
                <div className="input-group-append">
                  <label className="input-group-text" htmlFor="categoriaIVA">
                    *
                  </label>
                </div>
              </div>
            </div>
          ) : null}

          <label className="labelPerfil" htmlFor="nacionalidad">
            Nacionalidad
          </label>
          <div className="input-group">
            <select
              className="custom-select"
              name="nacionalidad"
              onChange={handleInputChange}
              value={usuario.cliente.nacionalidad}
            >
              {nacionalidades.map((nacionalidad) => {
                return (
                  <option key={nacionalidad.id} value={nacionalidad.codigo}>
                    {nacionalidad.denominacion}
                  </option>
                );
              })}
            </select>
            <div className="input-group-append">
              <label className="input-group-text" htmlFor="nacionalidad">
                *
              </label>
            </div>
          </div>

          <label className="labelPerfil" htmlFor="partido">
            Partido
          </label>
          <div className="input-group">
            <select
              className="custom-select"
              name="partido"
              value={usuario.cliente.partido.id}
              onChange={handlePartidoChange}
            >
              <option value="SIN">Elegir Partido</option>
              {partidos.map((partido) => {
                return (
                  <option key={partido.id} value={partido.id}>
                    {partido.denominacion}
                  </option>
                );
              })}
            </select>
            <div className="input-group-append">
              <label className="input-group-text white" htmlFor="partido">
                *
              </label>
            </div>
          </div>

          <label className="labelPerfil" htmlFor="tipoDocumento">
            Tipo Documento
          </label>
          <div className="input-group">
            <select
              name="tipoDocumento"
              className="custom-select"
              onChange={handleTipoDocumentoChange}
              value={usuario.cliente.tipoDocumento.sigla}
            >
              {tiposDocumento.map((tipoDeDocumento) => {
                return (
                  <option
                    key={tipoDeDocumento.idTipoDocumento}
                    value={tipoDeDocumento.sigla}
                  >
                    {tipoDeDocumento.sigla}
                  </option>
                );
              })}
            </select>
            <div className="input-group-append">
              <label className="input-group-text" htmlFor="tipoDocumento">
                *
              </label>
            </div>
          </div>

          <label className="labelPerfil" htmlFor="sexo">
            Sexo
          </label>
          <div className="input-group">
            <select
              className="custom-select"
              value={usuario.cliente.sexo}
              name="sexo"
              onChange={handleInputChange}
            >
              <option value="M">Masculino</option>
              <option value="F">Femenino</option>
            </select>
            <div className="input-group-append">
              <label className="input-group-text" htmlFor="sexo">
                *
              </label>
            </div>
          </div>

          <div className="input-group">
            <label className="labelPerfil" htmlFor="direccion">
              Calle
            </label>
            <input
              value={usuario.cliente.direccion}
              name="direccion"
              placeholder="Ej: Corrientes 1234"
              type="text"
              onChange={handleInputChange}
            />
            <div className="input-group-append">
              <label className="input-group-text" htmlFor="direccion">
                *
              </label>
            </div>
          </div>

          <div className="input-group">
            <label className="labelPerfil" htmlFor="numeroCalle">
              N&uacute;mero
            </label>
            <input
              value={usuario.cliente.numeroCalle}
              name="numeroCalle"
              placeholder="Número"
              type="number"
              onChange={handleInputChange}
            />
            <div className="input-group-append">
              <label className="input-group-text" htmlFor="numeroCalle"></label>
            </div>
          </div>

          <div className="input-group">
            <label className="labelPerfil" htmlFor="cp">
              Codigo Postal
            </label>
            <input
              value={usuario.cliente.codigoPostal}
              name="codigoPostal"
              placeholder="Cod. Postal"
              type="text"
              onChange={handleInputChange}
            />
            <div className="input-group-append">
              <label className="input-group-text" htmlFor="numeroCalle"></label>
            </div>
          </div>
        </div>

        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 txt">
          <div className="input-group">
            <label className="labelPerfil" htmlFor="mail">
              Email
            </label>
            <input
              type="email"
              value={usuario.cliente.mail}
              name="mail"
              placeholder="ejemplo@gmail.com"
              onChange={handleInputChange}
              className={usuario.cliente.mail === "" ? "error" : ""}
            />
            <div className="input-group-append">
              <label className="input-group-text" htmlFor="mail">
                *
              </label>
            </div>
          </div>

          {usuario.tipoCliente === "AGE" ? (
            <div className="input-group">
              <label className="labelPerfil" htmlFor="legajo">
                Legajo
              </label>
              <input
                value={usuario.cliente.legajo}
                name="legajo"
                placeholder="N° Legajo"
                type="number"
                onChange={handleInputChange}
                className={usuario.cliente.legajo === "" ? "error" : ""}
              />
              <div className="input-group-append">
                <label className="input-group-text" htmlFor="legajo">
                  *
                </label>
              </div>
            </div>
          ) : null}

          <label className="labelPerfil" htmlFor="provincia">
            Provincia
          </label>
          <div className="input-group">
            <select
              className="custom-select"
              name="provincia"
              value={usuario.cliente.provincia.codigo}
              onChange={handleProvinciaChange}
            >
              <option value="SIN">Elegir Provincia</option>
              {provincias.map((provincia) => {
                return (
                  <option key={provincia.id} value={provincia.codigo}>
                    {provincia.denominacion}
                  </option>
                );
              })}
            </select>
            <div className="input-group-append">
              <label className="input-group-text white" htmlFor="provincia">
                *
              </label>
            </div>
          </div>

          
          <label className="labelPerfil" htmlFor="localidad">
            Localidad
          </label>
          <div className="input-group">
            <select
              className="custom-select"
              name="localidad"
              value={usuario.cliente.localidad.id}
              onChange={handleLocalidadChange}
            >
              <option value="0">Elegir Localidad</option>
              {localidades.map((loc) => {
                return (
                  <option key={loc.id} value={loc.id}>
                    {loc.denominacion}
                  </option>
                );
              })}
            </select>
            <div className="input-group-append">
              <label className="input-group-text white" htmlFor="localidad">
                *
              </label>
            </div>
          </div>

          <label className="labelPerfil" htmlFor="pais">
            País Residencia
          </label>
          <div className="input-group">
            <select
              className="custom-select"
              name="pais"
              value={usuario.cliente.pais.codigo}
              onChange={handlePaisChange}
            >
              <option value="SIN">Elegir Pais</option>
              {nacionalidades.map((nacionalidad) => {
                return (
                  <option key={nacionalidad.id} value={nacionalidad.codigo}>
                    {nacionalidad.denominacion}
                  </option>
                );
              })}
            </select>
            <div className="input-group-append">
              <label className="input-group-text white" htmlFor="pais">
                *
              </label>
            </div>
          </div>

          <div className="input-group">
            <label className="labelPerfil" htmlFor="numeroDocumento">
              N° Documento
            </label>
            <input
              value={usuario.cliente.numeroDocumento}
              name="numeroDocumento"
              placeholder="N° Documento"
              type="number"
              onChange={handleInputChange}
            />
            <div className="input-group-append">
              <label className="input-group-text" htmlFor="numeroDocumento">
                *
              </label>
            </div>
          </div>

          <div className="input-group">
            <label className="labelPerfil" htmlFor="telefono">
              Telefono
            </label>
            <input
              value={usuario.cliente.telefono}
              name="telefono"
              placeholder="Telefono"
              type="text"
              onChange={handleInputChange}
            />
            <div className="input-group-append">
              <label className="input-group-text" htmlFor="telefono"></label>
            </div>
          </div>

          <div className="input-group">
            <label className="labelPerfil" htmlFor="celular">
              Celular
            </label>
            <input
              value={usuario.cliente.celular}
              name="celular"
              placeholder="Celular"
              type="text"
              onChange={handleInputChange}
            />
            <div className="input-group-append">
              <label className="input-group-text" htmlFor="celular"></label>
            </div>
          </div>

          <label className="labelPerfil" htmlFor="fechaNacimiento">
            Fecha Nacimiento
          </label>
          <div className="input-group">
            <input
              type="date"
              value={usuario.cliente.fechaNacimiento}
              name="fechaNacimiento"
              placeholder="Fecha Nacimiento"
              onChange={handleInputChange}
            />
            <div className="input-group-append">
              <label className="input-group-text" htmlFor="fechaNacimiento">
                *
              </label>
            </div>
          </div>

          <br />
          <input
            type="submit"
            className="botonInicio"
            value="Guardar Cambios"
            onClick={handleGuardarDatosPersonalesClick}
          />
        </div>
      </form>
    </div>
  );
};

export default withRouter(DatosPersonales);

DatosPersonales.propTypes = {
  usuario: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/MiPerfil/DatosPersonales/index.js